export default {
    Title: 'Tham số báo cáo',
    ChoosePeriod: 'Chọn kỳ báo cáo',
    ChoosePeriodLite: 'Kỳ báo cáo',
    FromDate: 'Từ ngày',
    ToDate: 'Đến ngày',
    PrintAdjustMonth: 'In tháng chỉnh lý quyết toán',
    IncludeAdjustVoucher: 'Bao gồm chứng từ chỉnh lý quyết toán',
    PrintChapter800: 'In chương 800',
    Unit: 'Đơn vị tính',
    Brass: 'Đồng',
    ThousandBrass: 'Nghìn đồng',
    MillionBrass: 'Triệu đồng',
    AdjustMonth : 'Tháng chỉnh lý quyết toán'
};
